/** Words on the Copilot home page, shared by the current and the new one. */

/** Questions to start with when the workspace has none of its own yet. */
export const DEFAULT_SUGGESTED_PROMPTS = [
  'What was total revenue last month?',
  'Why did order volume drop in Q4?',
  'Show me top 10 customers by spend',
  'Compare this month vs same month last year',
];

export function getTimeOfDayGreeting(now: Date = new Date()): string {
  const h = now.getHours();
  if (h < 5) return 'Up late';
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

/** The signed-in person's first name, from their profile or email. */
export function getFirstName(): string | null {
  try {
    const raw = window.localStorage.getItem('klaris_user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    const full = (u?.full_name || u?.name || '').trim();
    if (full) return full.split(/\s+/)[0] || null;
    const email = (u?.email || '').trim();
    if (email) {
      const local = email.split('@')[0] || '';
      const cleaned = local.split(/[._+-]/)[0] || '';
      if (cleaned) return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
    }
  } catch { /* ignore */ }
  return null;
}
